import { systemAuditConstants } from "../_constants";

export function systemAuditList(state = {}, action) {
  switch (action.type) {
    case systemAuditConstants.GET_ALL_SYSTEM_AUDIT_REQUEST:
      return {
        loading: true,
      };
    case systemAuditConstants.GET_ALL_SYSTEM_AUDIT_SUCCESS:
      return {
        items: action.systemAudit,
      };
    case systemAuditConstants.GET_ALL_SYSTEM_AUDIT_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function systemAuditTopCard(state = {}, action) {
  switch (action.type) {
    case systemAuditConstants.SYSTEM_AUDIT_TOP_CARD_REQUEST:
      return {
        loading: true,
      };
    case systemAuditConstants.SYSTEM_AUDIT_TOP_CARD_SUCCESS:
      return {
        items: action.systemAuditCards,
      };
    case systemAuditConstants.SYSTEM_AUDIT_TOP_CARD_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}
//fetchSystemAuditFilters
export function fetchSystemAuditFilters(state={},action){
  switch(action.type){
    case systemAuditConstants.GET_ALL_SYSTEM_AUDIT_FILTERS_REQUEST:
      return {
        loading:true,
      };
      case systemAuditConstants.GET_ALL_SYSTEM_AUDIT_FILTERS_SUCCESS:
        return {
          items:action.auditFilters,
        };
      case systemAuditConstants.GET_ALL_SYSTEM_AUDIT_FILTERS_FAILURE:
        return{
          error:action.error,
        };
       default:
         return state; 
  }
}